<template>
  <div class="col-md-4 offset-md-4">
    <div class="card shadow mb-4">
      <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
        <h6 class="m-0 font-weight-bold">{{ $t('Change_password') }}</h6>
      </div>
      <div class="card-body text-center">
        <form class="user" v-on:submit="submit">
          <div v-if="error" class="alert alert-danger" role="alert">
            <span>{{ error }}</span>
          </div>
          <div v-if="success" class="alert alert-success" role="alert">
            <span>{{ $t('Password_changed_successfully') }}</span>
          </div>
          <div class="form-group">
            <input
              type="password"
              v-model="input.old_password"
              autocomplete="false"
              class="form-control form-control-user"
              id="current_password"
              required
              aria-describedby="emailHelp"
              :placeholder="$t('Current_password')"
            />
          </div>
          <div class="form-group">
            <input
              type="password"
              v-model="input.new_password"
              class="form-control form-control-user"
              id="new_password"
              required
              :placeholder="$t('New_password')
            "
            />
          </div>
          <div class="form-group">
            <input
              type="password"
              v-model="input.new_password_2"
              class="form-control form-control-user"
              id="new_password_2"
              :placeholder="$t('New_password')"
            />
          </div>
          <input
            type="submit"
            :value="$t('Change_password')"
            class="btn btn-primary btn-user btn-block"
          />
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Settings",
  data() {
    return {
      input: {
        old_password: null,
        new_password: null,
        new_password_2: null
      },
      success: false,
      error: null
    };
  },
  methods: {
    submit: function(e) {
      e.preventDefault();
      if (this.input.old_password == null || this.input.new_password == null || this.input.new_password_2 == null)
        this.error = this.$i18n.t('Please_fill_all_fields')
      else if (this.input.new_password !== this.input.new_password_2)
        this.error = this.$i18n.t("Passwords_dont_match")
      else {
        this.$store
          .dispatch("changePassword", {
            old_password: this.input.old_password,
            new_password: this.input.new_password,
            new_password2: this.input.new_password_2
          })
          .then(() => { 
            this.error = null
            this.success = true 
          })
          .catch(err => {
            if (err === "WRONG_OLD_PASSWORD") this.error = this.$i18n.t('Wrong_old_password')
            else if (err == "NEW_PASSWORD_NOT_MATCH") this.error = this.$i18n.t('Passwords_dont_match')
            else this.error = this.$i18n.t("An_error_occurred");
          });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
